module.exports = __webpack_public_path__ + "media/images/about_us/navigator-7845190c29f56f6ab44613982672d5a3.svg";